export const ONLINE_STATUS = 'Online';
export const OFFLINE_STATUS = 'Offline';
export const RECORDING_STATUS = 'Recording';
export const FILTER_OPTIONS = [ONLINE_STATUS, OFFLINE_STATUS, RECORDING_STATUS];
